/**
 * Configuración SEO por ruta.
 *
 * El título de cada página lo sigue fijando su componente (Title service);
 * acá se define la meta description, si la ruta se indexa y la URL canónica.
 * Las reglas se evalúan en orden: gana la primera cuyo `match` coincide.
 */
export const SEO_SITE_URL = 'https://sismat.com.ar';

export const SEO_DEFAULT_DESCRIPTION =
  'Sismat es la app de cómputo y presupuesto de obra para arquitectos, constructores y MMO: ' +
  '+400 tareas, +1.300 materiales y salarios UOCRA con precios actualizados en Argentina.';

export interface SeoRouteRule {
  match: RegExp;
  description?: string;
  /** false = noindex,follow (páginas privadas, de cuenta o de bajo valor para buscadores) */
  index?: boolean;
}

export const SEO_ROUTE_RULES: SeoRouteRule[] = [
  {
    match: /^\/$/,
    description: SEO_DEFAULT_DESCRIPTION
  },
  {
    match: /^\/suscribirse$/,
    description:
      'Planes de Sismat, la app de cómputo y presupuesto de obra. Elegí tu plan trimestral, semestral ' +
      'o anual y accedé a costos de materiales, mano de obra y UOCRA actualizados todos los meses.'
  },
  {
    match: /^\/computo\/pre-establecido\/\d+$/,
    description:
      'Cómputo y presupuesto de obra de referencia con cantidades por rubro, materiales y mano de obra ' +
      'a precios actualizados de Argentina. Hecho con Sismat.'
  },
  {
    match: /^\/terminos-y-condiciones$/,
    description: 'Términos y condiciones de uso de Sismat, la app de cómputo y presupuesto de obra.'
  },
  {
    match: /^\/protecci(ó|%C3%B3|o)n-de-datos-personales$/i,
    description: 'Política de protección de datos personales de Sismat (Ley 25.326).'
  },
  // Páginas de cuenta, pago, herramientas internas y áreas privadas: no indexar.
  { match: /^\/usuarios(\/|$)/, index: false },
  { match: /^\/(aplicar-cupon|renovar-suscripcion|ux)(\/|$)/, index: false },
  { match: /^\/(mis-computos|cronograma)(\/|$)/, index: false },
  { match: /^\/computo(\/|$)/, index: false },
  { match: /^\/(costos|detalles-constructivos|calculadora-de-costos-uocra)(\/|$)/, index: false }
];
